import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

type ItemProps = {
  $end?: boolean;
};
const Item = styled.div<ItemProps>`
  &:not(:first-child) {
    padding-top: var(--spacing-05);
  }
  ${ifProp(
    '$end',
    css`
      display: flex;
      justify-content: flex-end;
    `,
  )};
`;

const WrapperComp = styled.div`
  padding: var(--spacing-05);
  padding-bottom: var(--spacing-12);
  padding-left: var(--left-spacing);
`;

type WrapperComposition = typeof WrapperComp & {
  Item: typeof Item;
};
const Wrapper: WrapperComposition = WrapperComp as any;

Wrapper.Item = Item;

export { Wrapper };
